import React from 'react';
import { useStyles } from './useStyles';
import { Typography } from '@mui/material';

interface IPolicyTypeProps {
  data: any;
  type: string;
}

const CuminPolicies = (props: IPolicyTypeProps) => {
  const classes = useStyles();
  const { data, type } = props;
  return (
    <div className={classes.container}>
      {data.map((item: any, index: number) => {
        const { title, paragraphs, id } = item;
        return (
          <div key={id}>
            {title && (
              <div className={classes.itemTitle}>
                <Typography variant="body1" color="garamMasala.main">
                  {type === 'Terms & Conditions' && `(${index + 1}) `}
                  {title}
                </Typography>
              </div>
            )}

            {paragraphs.map((paragraph: any) => {
              const { text, list } = paragraph;
              return (
                <>
                  <div
                    className={classes.text}
                    style={{ marginBottom: list ? '0' : '20px' }}
                  >
                    <Typography variant="body2" color="garamMasala.main">
                      {text}
                    </Typography>
                  </div>
                  {list && (
                    <ul className={classes.listWrapper}>
                      {list.map((item: any) => {
                        const { text, id } = item;
                        return (
                          <li key={id} className={classes.list}>
                            <Typography
                              variant="body2"
                              color="garamMasala.main"
                            >
                              {text}
                            </Typography>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default CuminPolicies;
